import type { LiveComponent } from '@use-gpu/live';
import type { OffscreenTarget, UseGPURenderContext } from '@use-gpu/core';

import { yeet } from '@use-gpu/live';

import { usePassContext } from '../../providers/pass-provider';

import { useTextureAccess } from '../../hooks/useTextureAccess';
import { useShader } from '../../hooks/useShader';
import { useShaderRef } from '../../hooks/useShaderRef';

import { useCopySample } from '../copy/value-copy';

import { getOITResolve } from '@use-gpu/wgsl/oit/oit-resolve.wgsl';

export type OITDispatchProps = {
  bindPass?: (r: GPURenderPassEncoder) => void,
  globalLayout?: GPUBindGroupLayout,

  targetContext: UseGPURenderContext,
  descriptor: GPURenderPassDescriptor,
};

export const OITDispatch: LiveComponent<OITDispatchProps> = (props: OITDispatchProps) => {
  const {
    bindPass,
    globalLayout,

    targetContext,
    descriptor,
  } = props;

  const {
    targets: {oit},
  } = usePassContext();

  const [transparencyContext] = oit as OffscreenTarget[];
  const renderSize = useShaderRef([transparencyContext.width, transparencyContext.height]);

  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  const [colorSource, revealageSource] = transparencyContext.sources!;

  const loadColor = useTextureAccess(colorSource);
  const loadRevealage = useTextureAccess(revealageSource);

  const getResolve = useShader(getOITResolve, [
    loadColor,
    loadRevealage,
    renderSize,
  ]);

  const blendState: GPUBlendState = {
    color: { srcFactor: 'src-alpha', dstFactor: 'one-minus-src-alpha' },
    alpha: { srcFactor: 'one', dstFactor: 'one' },
  };
  const draw = useCopySample(targetContext, getResolve, globalLayout, blendState);

  const command = (commandEncoder: GPUCommandEncoder) => {
    const passEncoder = commandEncoder.beginRenderPass(descriptor);
    bindPass?.(passEncoder);
    draw?.(passEncoder);
    passEncoder.end();
  };

  return yeet({ oit: command });
};

